__turbopack_context__.v({
  "adviewTop": "index-module-scss-module__6OciCa__adviewTop",
  "aside-skyscraper": "index-module-scss-module__6OciCa__aside-skyscraper",
  "aside-wrapper": "index-module-scss-module__6OciCa__aside-wrapper",
  "billboard": "index-module-scss-module__6OciCa__billboard",
  "left-aside": "index-module-scss-module__6OciCa__left-aside",
  "main": "index-module-scss-module__6OciCa__main",
  "right-aside": "index-module-scss-module__6OciCa__right-aside",
  "skeleton": "index-module-scss-module__6OciCa__skeleton",
});
